import { render } from "./AuthorComplete.vue?vue&type=template&id=59db7fb8&scoped=true&ts=true"
import script from "./AuthorComplete.vue?vue&type=script&lang=ts"
export * from "./AuthorComplete.vue?vue&type=script&lang=ts"

import "./AuthorComplete.vue?vue&type=style&index=0&id=59db7fb8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59db7fb8"]])

export default __exports__